import { SET_CURRENT_USER, LOGOUT, SET_CURRENT_LANGUAGE } from './types';
import { SET_AUTH_LOADING } from './AppContext';

export const appReducer = (state, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    case LOGOUT: 
      return {
        ...state,
        user: null, 
        isAuthenticated: false,
      };
    case SET_CURRENT_LANGUAGE:
      return {
        ...state,
        currentLanguage: action.payload,
      };
    case SET_AUTH_LOADING:
      return {
        ...state,
        authLoading: action.payload,
      };
    default:
      return state;
  }
};